import { IdentifierDTO } from '@zazume/zzm-base';
import { doGet, doPost, doDelete, toPaginatedURL } from '../../helpers';
import { PaginationOptions } from '#/hooks';
import { RewardAccount, RewardTransaction } from '#/models/rewards/RewardAccount';

export const rewards = {
  getBalance: (tenantId: IdentifierDTO) => () =>
    doGet<RewardAccount>(`/rewards/tenants/${tenantId}/balance`),

  getTransactions: (tenantId: IdentifierDTO) =>
    (pagination: PaginationOptions) =>
      () =>
        doGet<RewardTransaction[]>(
          toPaginatedURL(`/rewards/tenants/${tenantId}/transactions`, pagination)
        ),

  addPoints: (tenantId: IdentifierDTO) => (data: { points: number; description: string }) =>
    doPost<{ ledgerEntryId: string }>(`/rewards/tenants/${tenantId}/points`, data),

  deductPoints: (tenantId: IdentifierDTO) => (data: { points: number; description: string }) =>
    doDelete<void>(`/rewards/tenants/${tenantId}/points`, data),

  activateAccount: (tenantId: IdentifierDTO) => () =>
    doPost<void>(`/rewards/tenants/${tenantId}/activate`, {})
};
